import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth  } from '../context/AuthContext';
import { formatDate, formatDateOnly } from '../utils/dateUtils';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Calendar } from '../components/ui/calendar';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from 'react-datepicker';
export { DateInput } from '../components/Calendericon';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../components/ui/dialog';
import { Label } from '../components/ui/label';
import { useUpdatePatient , useShowPatient ,useTogglePatientStatus } from '../hooks/useApi';
import { hasAnyPermission} from '@/utils/permissions';


import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../components/ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Switch } from '../components/ui/switch';
import { Plus, Search, Filter, User, Edit } from 'lucide-react';
import { useListPatient } from '../hooks/useApi';
import { toast } from 'react-toastify';
import { useDebounce } from '@/hooks/useDebounce';
import { DateInput } from '@/components/Calendericon';



const PatientList = () => {
  const navigate = useNavigate();

  const { currentUser } = useAuth();

  const [searchQuery, setSearchQuery] = useState('');
  const [diagnosisFilter, setDiagnosisFilter] = useState('all');

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [dateRange, setDateRange] = useState([null, null]);
  const [fromDate, toDate] = dateRange;

  const from_date = formatDateOnly(fromDate);
  const to_date = formatDateOnly(toDate);


  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editPatientData, setEditPatientData] = useState(null);

 const [statusFilter, setStatusFilter] = useState(null);

 const [formData, setFormData] = useState({
  full_name: '',
  age: '',
  gender: '',
  phone: '',
  address: '',
  diagnosis: [],        
  diagnosisInput: '',   
  treatment_plan: '',
  medical_history: '',
});

  
 
  
const handleSavePatient = () => {
  if (!editPatientData?.id) return;

  const payload = {
    full_name: formData.full_name,
    age: formData.age,
    gender: formData.gender,
    phone: formData.phone,
    address: formData.address,
    treatment_plan: formData.treatment_plan,
    medical_history: formData.medical_history,
    diagnosis: formData.diagnosis,
  };

  updatePatient(
    { id: editPatientData.id, payload },
    {
      onSuccess: () => {
        toast.success('Patient updated successfully');
        setIsEditModalOpen(false);
      },
      onError: () => {
        toast.error('Failed to update patient');
      },
    }
  );
};
  const { mutate: updatePatient, isPending: isUpdatingPatient } = useUpdatePatient();



  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const { data: patientsdata, isLoading, error } = useListPatient(debouncedSearchQuery, currentPage, from_date, to_date, statusFilter === 'all' ? undefined : statusFilter);

  // Extract patients array from API response
  const patientslist = patientsdata?.data?.data || [];
  const totalPatients = patientsdata?.data?.total || 0;
  const from = patientsdata?.data?.from;

  const { data: patientData, isLoading: isPatientLoading, error: patientError } = useShowPatient(editPatientData?.id);
 
 
useEffect(() => {
  if (patientData?.data) {
    setFormData({
      full_name: patientData.data.full_name || '',
      age: patientData.data.age || '',
      gender: patientData.data.gender || '',
      phone: patientData.data.phone || '',
      address: patientData.data.address || '',

      diagnosis: Array.isArray(patientData.data.diagnosis)
        ? patientData.data.diagnosis
        : typeof patientData.data.diagnosis === 'string'
          ? patientData.data.diagnosis.split(',').map(d => d.trim())
          : [],

      diagnosisInput: '',
      treatment_plan: patientData.data.treatment_plan || '',
      medical_history: patientData.data.medical_history || '',
    });
  }
}, [patientData]);

  


  // Get unique diagnoses from the patient list (for filter dropdown - will be replaced by API later)
  const uniqueDiagnoses = [...new Set(patientslist.map((p) => p.diagnosis).filter(Boolean))];

  useEffect(() => {
    if (!patientsdata?.data) return;

    setCurrentPage(patientsdata.data.current_page);
    setTotalPages(patientsdata.data.last_page);
  }, [patientsdata]);


  const getPageStyle = (page) => {
    const intensity = page / totalPages;

    if (page === currentPage) {
      return 'bg-primary-600 text-white scale-110';
    }

    if (intensity < 0.4) return 'bg-gray-100 text-gray-600';
    if (intensity < 0.7) return 'bg-gray-200 text-gray-700';
    return 'bg-gray-300 text-gray-800';
  };

  const handleEditPatient = (patient) => {
    setEditPatientData(patient);
    setIsEditModalOpen(true);
  };

  const [isStatusDialogOpen, setIsStatusDialogOpen] = useState(false);
  const [statusToggleData, setStatusToggleData] = useState(null);

  const handleToggleStatus = (patientId, currentStatus) => {
    setStatusToggleData({ patientId, currentStatus });
    setIsStatusDialogOpen(true);
  };

const confirmStatusToggle = () => {
  if (!statusToggleData) return;

  const { patientId } = statusToggleData;

  togglePatientStatus(patientId, {
    onSuccess: () => {
      toast.success('Patient status updated successfully');
    
      setIsStatusDialogOpen(false);
      setStatusToggleData(null);
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.message || 'Failed to update patient status'
      );
      setIsStatusDialogOpen(false);
      setStatusToggleData(null);
    },
  });
};



  const handleDiagnosisKeyDown = (e) => {
  if (e.key === ',' || e.key === 'Enter') {
    e.preventDefault();

    const value = formData.diagnosisInput.trim();
    if (!value) return;

    if (!formData.diagnosis.includes(value)) {
      setFormData((prev) => ({
        ...prev,
        diagnosis: [...prev.diagnosis, value],
        diagnosisInput: '',
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        diagnosisInput: '',
      }));
    }
  }
};

const removeDiagnosis = (index) => {
  setFormData((prev) => ({
    ...prev,
    diagnosis: prev.diagnosis.filter((_, i) => i !== index),
  }));
};

const { mutate: togglePatientStatus, isPending } = useTogglePatientStatus();






  return (
    <div className="space-y-6 animate-fadeIn">
      {/* Header */}


      {/* Filters */}
      <Card>
        <CardContent className="p-6">
          <div className="flex justify-between flex-wrap gap-4">
            {/* Search */}
            <div className="">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                <Input
                  placeholder="Search by name or diagnosis..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-10"
                />
              </div>
            </div>

            {/* Diagnosis Filter - UI only, API integration pending */}
            {/* <div className="">
              <Select value={diagnosisFilter} onValueChange={setDiagnosisFilter}>
                <SelectTrigger>
                  <div className="flex items-center gap-2">
                    <Filter className="w-4 h-4" />
                    <SelectValue placeholder="Filter by diagnosis" />
                  </div>
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Diagnoses</SelectItem>
                  {uniqueDiagnoses.map((diagnosis) => (
                    <SelectItem key={diagnosis} value={diagnosis}>
                      {diagnosis}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div> */}

            <div className="">
              <DatePicker

                selectsRange
                startDate={fromDate}
                endDate={toDate}
                onChange={(update) => {
                  setDateRange(update);
                }}
                isClearable
                placeholderText="Select date range"
                className="border rounded-lg   py-2"
                popperClassName="datepicker-popper"
                customInput={<DateInput />}

              />
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <span>Patient Status :-</span>
  <Button
    size="sm"
    variant={statusFilter === null ? 'default' : 'outline'}
    onClick={() => setStatusFilter(null)}
  >
    All
  </Button>

  <Button
    size="sm"
    variant={statusFilter === 1 ? 'default' : 'outline'}
    onClick={() => setStatusFilter(1)}
  >
    Active
  </Button>

  <Button
    size="sm"
    variant={statusFilter === 0 ? 'default' : 'outline'}
    onClick={() => setStatusFilter(0)}
  >
    Deactive
  </Button>
</div>

            {hasAnyPermission(currentUser, ['patient.create','all']) && (
            <div>  
              <Button
                onClick={() => navigate('/patients/add')}
                className="bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white"
              >
                <Plus className="w-4 h-4 mr-2" />
                Add Patient
              </Button>
            </div>
)}

            <div>
              <p className="text-gray-600 text-end mt-1">{totalPatients} Patient(s) found</p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Loading State */}
      {isLoading ? (
        <Card>
          <CardContent className="p-12">
            <div className="text-center">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Loading patients...</h3>
            </div>
          </CardContent>
        </Card>
      ) : error ? (
        <Card>
          <CardContent className="p-12">
            <div className="text-center">
              <h3 className="text-lg font-semibold text-red-900 mb-2">Error loading patients</h3>
              <p className="text-gray-600">{error.response.data.message || 'Please try again later'}</p>
            </div>
          </CardContent>
        </Card>
      ) : patientslist.length === 0 ? (
        <Card>
          <CardContent className="p-12">
            <div className="text-center">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <User className="w-10 h-10 text-gray-400" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">No patients found</h3>
              <p className="text-gray-600 mb-6">Get started by adding your first patient</p>
              {hasAnyPermission(currentUser, ['patient.create','all']) && (
              <Button
                onClick={() => navigate('/patients/add')}
                className="bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white"
              >
                <Plus className="w-4 h-4 mr-2" />
                Add Patient
              </Button>
              )}
            </div>
          </CardContent>
        </Card>
      ) : (
        <Card className="overflow-y-auto max-h-[72vh]">
          <CardContent className="p-0">
            <Table>
              <TableHeader >
                <TableRow className="z-20">
                  <TableHead className="text-center">Sr. No.</TableHead>
                  <TableHead className="text-center">Patient Name</TableHead>
                  <TableHead className="text-center">Patient ID</TableHead>
                  <TableHead className="text-center">Diagnosis</TableHead>
                  <TableHead className="text-center">Age/Gender</TableHead>
                  <TableHead className="text-center">Created By</TableHead>
                  <TableHead className="text-center">Date Added</TableHead>

                    {hasAnyPermission(currentUser, ['patient.update','all']) && (
                    <TableHead className="text-center">Actions</TableHead>
                    )}
                </TableRow>
              </TableHeader>
              <TableBody>
                {patientslist.map((patient, index) => (
                  
                  <TableRow
                    key={patient.id}
                    className="cursor-pointer hover:bg-gray-50 transition-colors"

                  >
                    <TableCell className="text-center">

                      <span className="text-black  text-lg">
                        {from + index}
                      </span>

                    </TableCell>
                    <TableCell className="text-center font-medium">
                      <span
                        onClick={() => navigate(`/patients/${patient?.id}`)}
                        className="cursor-pointer text-primary-600 underline hover:text-primary-700"
                      >
                        {patient?.full_name || 'N/A'}
                      </span>
                    </TableCell>

                    <TableCell className="text-center text-gray-600">{patient?.patient_uid || 'N/A'}</TableCell>
                    <TableCell className="text-center">
                      <div className="flex flex-wrap justify-center gap-1">
                        {patient?.diagnosis?.length > 0 ? (
                          patient.diagnosis.map((diag, i) => (
                            <Badge
                              key={i}
                              className="bg-primary-100 text-primary-700 hover:bg-primary-100"
                            >
                              {diag}
                            </Badge>
                          ))
                        ) : <span className="text-gray-400 text-sm">N/A</span>}
                      </div>
                    </TableCell>

                    <TableCell className="text-center">{patient?.age || 'N/A'} / {patient?.gender || 'N/A'}</TableCell>
                    <TableCell className="text-center">{patient?.created_by_name || 'N/A'}</TableCell>
                    <TableCell className="text-center text-gray-600">
                      {formatDate(patient?.created_at)}
                    </TableCell>

                  
                     {hasAnyPermission(currentUser, ['patient.update','all']) && (
                    <TableCell className="text-center flex items-center justify-center gap-2">
                     
                      {hasAnyPermission(currentUser, ['patient.update','all']) && (
                         <div>
                      <Button variant="ghost" size="icon" onClick={() => handleEditPatient(patient)}>
                        <Edit className="w-4 h-4 text-primary-600 hover:text-primary-700" />
                      </Button>
                        </div>
                      )}
                    
                       <div className="flex items-center justify-center">
                        {hasAnyPermission(currentUser, ['patient.update','all']) ? (
                        <Switch
  checked={patient?.is_active === 1}
  onCheckedChange={() => handleToggleStatus(patient.id, patient?.is_active)}
  // disabled={isToggling}
/>

                        ) : (
                          <span className="text-sm text-gray-600">{patient?.is_active === 1 ? 'Active' : 'Inactive'}</span>
                        )}
                      </div>

                    </TableCell> 
                     )} 
                  </TableRow>
                ))}
              </TableBody>
            </Table>

          </CardContent>

        </Card>

      )}

<Dialog open={isEditModalOpen} onOpenChange={setIsEditModalOpen}>
  <DialogContent className="sm:max-w-xl w-[95vw] h-[95vh] overflow-y-auto">
    <DialogHeader>
      <DialogTitle>Edit Patient</DialogTitle>
    </DialogHeader>

    {/* Loading state */}
    {isPatientLoading && (
      <div className="flex justify-center items-center py-10">
        <div className="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin" />
      </div>
    )}

    {/* Form (render AFTER loading) */}
    {!isPatientLoading && (
      <div className="space-y-4">
        <div className="flex flex-col gap-2">
          <Label className="text-sm text-gray-600">Full Name <span className="text-red-500">*</span></Label>
          <Input
            value={formData.full_name}
            onChange={(e) =>
              setFormData({ ...formData, full_name: e.target.value })
            }
            onKeyPress={(e) => {
                    if (!/^[a-zA-Z\s]*$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }} 
          />
        </div>

        <div className="sm:flex w-full gap-2">
          <div className="flex flex-col gap-2 w-full">
            <Label className="text-sm text-gray-600">Age</Label>
            <Input
              value={formData.age}
              onChange={(e) =>
                setFormData({ ...formData, age: e.target.value })
              }
              maxLength={2}
                  onKeyPress={(e) => {
                    if (!/^\d*$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
              
            />
          </div>

          <div className="flex flex-col gap-2 w-full">
  <Label className="text-sm text-gray-600">
    Gender <span className="text-red-500">*</span>
  </Label>

  <Select
    value={formData.gender}
    onValueChange={(value) =>
      setFormData({ ...formData, gender: value })
    }
  >
    <SelectTrigger>
      <SelectValue placeholder="Select gender" />
    </SelectTrigger>

    <SelectContent>
      <SelectItem value="Male">Male</SelectItem>
      <SelectItem value="Female">Female</SelectItem>
      <SelectItem value="other">Other</SelectItem>
    </SelectContent>
  </Select>
</div>


          <div className="flex flex-col gap-2 w-full">
            <Label className="text-sm text-gray-600">Contact Number <span className="text-red-500">*</span></Label>
            <Input
              value={formData.phone}
              onChange={(e) =>
                setFormData({ ...formData, phone: e.target.value })
              }
              maxLength={10}
                  onKeyPress={(e) => {
                    if (!/^\d*$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
            />
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <Label className="text-sm text-gray-600">Address</Label>
          <Input
            value={formData.address}
            onChange={(e) =>
              setFormData({ ...formData, address: e.target.value })
            }
             onKeyPress={(e) => {
                    if (!/^[a-zA-Z0-9,./\- ]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
          />
        </div>

       <div className="space-y-2">
  <Label htmlFor="diagnosis">
    Diagnosis <span className="text-red-500">*</span>
  </Label>

  <div className="flex flex-wrap items-center gap-2 border rounded-md p-2 min-h-[42px] focus-within:ring-2 focus-within:ring-primary-500">
    {formData.diagnosis.map((tag, index) => (
      <span
        key={index}
        className="flex items-center gap-1 bg-primary-100 text-primary-700 px-3 py-1 rounded-full text-sm"
      >
        {tag}
        <button
          type="button"
          onClick={() => removeDiagnosis(index)}
          className="hover:text-red-600"
        >
          ✕
        </button>
      </span>
    ))}

    <input
      type="text"
      className="flex-1 outline-none min-w-[120px]"
      placeholder="Type diagnosis and press comma"
      value={formData.diagnosisInput}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          diagnosisInput: e.target.value,
        }))
      }
      onKeyDown={handleDiagnosisKeyDown}
    />
  </div>
</div>


        <div className="flex flex-col gap-2">
          <Label className="text-sm text-gray-600">Treatment Plan</Label>
          <Input
            value={formData.treatment_plan}
            onChange={(e) =>
              setFormData({ ...formData, treatment_plan: e.target.value })
            }
             onKeyPress={(e) => {
                    if (!/^[a-zA-Z0-9,./\- ]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
          />
        </div>

        <div className="flex flex-col gap-2">
          <Label className="text-sm text-gray-600">Medical History</Label>
          <Input
            value={formData.medical_history}
            onChange={(e) =>
              setFormData({ ...formData, medical_history: e.target.value })
            }
            onKeyPress={(e) => {
                    if (!/^[a-zA-Z0-9,./\- ]$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
          />
        </div>
      </div>
    )}

    <DialogFooter>
      <Button variant="outline" onClick={() => setIsEditModalOpen(false)}>
        Cancel
      </Button>
      <Button onClick={handleSavePatient} >
        {isUpdatingPatient ? 'Updating...' : 'Update'}
      </Button>
    </DialogFooter>
  </DialogContent>
</Dialog>
 
  <Dialog open={isStatusDialogOpen} onOpenChange={setIsStatusDialogOpen}>
    <DialogContent className="sm:max-w-md w-[95vw]">
      <DialogHeader>
        <DialogTitle>Confirm Status Change</DialogTitle>
        <DialogDescription>
          Are you sure you want to change the patient's status?
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button variant="outline" onClick={() => setIsStatusDialogOpen(false)}>Cancel</Button>
        <Button onClick={confirmStatusToggle} disabled={isPending}>{isPending ? 'Saving...' : 'Confirm'}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>

      {totalPages > 1 && (
        <div className="flex justify-center gap-2 mt-6">
          <Button
            variant="outline"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            Prev
          </Button>

          {Array.from({ length: totalPages }, (_, i) => {
            const page = i + 1;
            return (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`
          h-9 w-9 rounded-full transition-all
          ${getPageStyle(page)}
        `}
              >
                {page}
              </button>
            );
          })}

          <Button
            variant="outline"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next
          </Button>
        </div>
      )}


    </div>
  );
};

export default PatientList;
